export const defaultSettings = {
  title: "Botcircuits",
  subTitle: "Here to help",
  welcomeMessage: "",
  inputPlaceHolder: "Type a message...",
  logo: null,
  headerBackgroundColor: "#6366f1",
  headerTextColor: "#f9fafb",
  chatWindowBackgroundColor: "#f9fafb",
  sendBarBackgroundColor: "#e2e8f0",
  position: "bottom-right",
  launcherStyle: "bubble",
  textBarGlowEnabled: true,
  textBarGlowColor: "#3b82f6",
  tips: [],
  showPoweredBy: true,
};

// Each option sets both the launcher style and its position.
export const widgetLayouts = [
  { id: "bubble", label: "Chat bubble", hint: "A round launcher that opens a chat window", launcherStyle: "bubble", position: "bottom-right" },
  { id: "text-bar-right", label: "Text bar · right", hint: "An ask bar in the corner that grows into a chat", launcherStyle: "text-bar", position: "bottom-right" },
  { id: "text-bar-center", label: "Text bar · center", hint: "An ask bar centered at the bottom of the page", launcherStyle: "text-bar", position: "bottom-center" },
];

export function widgetLayoutId(settings) {
  if (settings.launcherStyle !== "text-bar") return "bubble";
  return settings.position === "bottom-center" ? "text-bar-center" : "text-bar-right";
}
